// it should do the request to update the speaker or word
import { useStation } from '@app/core/stations/hooks/useStation';
import { WpWordsType } from '@app/modules/search/types';
import { DateTimeStr } from '@mi-front/core';
import { apiClient } from '../../../../../../../api';
import { useFragmentCtx } from '../../../context/fragment-ctx';

export const useEditor = () => {
  const fragment = useFragmentCtx();
  const station = useStation(fragment.stationId);

  const handleUpdateSpeaker = async (
    fragmentId: string,
    time: DateTimeStr,
    diarization: {
      distance: number;
      segment: { start: number; end: number };
      label: string;
      voice_label: string;
    }[],
  ) => {
    try {
      await apiClient.fragments.patchTranscriptionSpeaker(fragmentId, station.slug, {
        time: time,
        // array with all the diarization segments
        diarization: diarization,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdateWords = async (
    fragmentId: string,
    time: DateTimeStr,
    wpWords: WpWordsType[],
  ) => {
    try {
      await apiClient.fragments.patchTranscription(fragmentId, station.slug, {
        time,
        wp_words: wpWords,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return {
    handleUpdateSpeaker,
    handleUpdateWords,
  };
};
